var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skeleton',{staticClass:"p-3 container",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},_vm._l((_vm.count),function(i){return _c('div',{class:'mt-2 ' + _vm.widthClass},[_c('tb-skeleton',{attrs:{"aspect-ratio":_vm.height}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }